import { createApp } from "vue";
import App from "./App.vue";
import "./tailwind.css";
import "@fortawesome/fontawesome-free/css/all.css"

const app = createApp(App);
app.mount("#app");
